import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { BillingPage } from './billing';
import { ChecklistTemplatesPage } from './checklist-templates';
import { ClientsPage } from './clients';
import { CommissionsPage } from './commissions';
import { OrdersPage } from './orders';
import { CreateOrderPage } from './orders/CreateOrderPage';
import { OrderEditPage } from './orders/edit';
import { RatesPage } from './rates';
import { RevenuePipelinePage } from './revenue-pipeline';
import { SubscriptionsPage } from './subscriptions';
import { UsersPage } from './users';

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="/billing" replace />} />
        <Route path="/billing" element={<BillingPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/new" element={<CreateOrderPage />} />
        <Route path="/orders/:id/edit" element={<OrderEditPage />} />
        <Route path="/rates" element={<RatesPage />} />
        <Route path="/commissions" element={<CommissionsPage />} />
        <Route path="/revenue-pipeline" element={<RevenuePipelinePage />} />
        <Route path="/subscriptions" element={<SubscriptionsPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/checklist-templates" element={<ChecklistTemplatesPage />} />
        <Route path="*" element={<Navigate to="/billing" replace />} />
      </Route>
    </Routes>
  );
}
